import { render, staticRenderFns } from "./pay-one-person-modal.vue?vue&type=template&id=1a3f7d15&scoped=true&"
import script from "./pay-one-person-modal.vue?vue&type=script&setup=true&lang=js&"
export * from "./pay-one-person-modal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./pay-one-person-modal.vue?vue&type=style&index=0&id=1a3f7d15&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3f7d15",
  null
  
)

export default component.exports